import { useCallback, useEffect, useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { createOrder, verifySignature } from "api/subscription/razorpay";
import { useAppDispatch } from "lib/redux/hooks";
import {
  setIsOutOfCreditsModalOpen,
  setIsPremiumUser,
} from "lib/redux/uiSlice";
import { useRouter } from "next/navigation";

const UpgradeToProCTAForm = ({ height }: { height: string }) => {
  const [containerHeight, setContainerHeight] = useState("h-full");
  useEffect(() => {
    setContainerHeight(height);
  }, [height]);
  const router = useRouter();
  const dispatch = useAppDispatch();
  const handleCloseModal = () => {
    dispatch(setIsOutOfCreditsModalOpen(false));
  };

  const handlePaymentSuccess = useCallback(async (response: any) => {
    try {
      const verificationResponse = await verifySignature(response);
      if (verificationResponse.verified) {
        dispatch(setIsOutOfCreditsModalOpen(false));
        dispatch(setIsPremiumUser(true));
        window.location.href = "/resume-builder";
      } else {
        alert("Payment verification failed.");
      }
    } catch (error) {
      alert("An error occurred during payment verification.");
    }
  }, []);

  const handlePayment = async () => {
    try {
      const response = await createOrder({
        planId: "1",
      });
      const orderDetails = response.data;
      const options = {
        key_id: process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID as string,
        amount: orderDetails.amount,
        currency: orderDetails.currency,
        order_id: orderDetails.id,
        name: "Resumemate",
        description: "Payment for subscription",
        image: "/assets/resumemateLogo.png",
        prefill: {
          name: "User's Name",
          email: "user@example.com",
          contact: "1234567890",
        },
        theme: {
          color: "#3399cc",
        },
        method: {
          paylater: false,
        },
        handler: handlePaymentSuccess,
        modal: {
          ondismiss: function () {
            console.log("Checkout form closed.");
            // handlePaymentDismiss();
          },
        },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      // setIsProcessing(false);
      console.error("Error...", error);
    }
  };

  return (
    <section className="absolute left-0 top-0 h-full w-full lg:px-[var(--resume-padding)]">
      <div
        className={`flex flex-col items-center rounded-3xl bg-white/25 pt-32 shadow-lg backdrop-blur-md`}
        style={{ height: containerHeight }}
      >
        <div className="relative flex h-[270px] w-full flex-col justify-between rounded-[18px] bg-[#2D2D2D] px-4 pb-24 pt-10 font-montserrat text-white md:w-[300px] xl:h-[306px] xl:w-[442px] xl:px-8 xl:pt-14">
          <div
            className="absolute right-2 top-2 h-5 w-5 cursor-pointer rounded-full bg-white p-[2px]"
            onClick={handleCloseModal}
          >
            <XMarkIcon className=" text-black" />
          </div>

          <p className="text-[10px] text-[#F8E297] xl:text-xs">
            Loving the Ai Experience?
          </p>
          <h3 className="text-sm font-semibold xl:text-base">
            Do more with Premium
          </h3>

          <p className="text-[10px] xl:text-xs">
            Subscribe today and create a
            <strong>
              high-scoring <br /> AI-enhanced ATS-friendly
            </strong>
            , resume that stands out!
          </p>

          <ul className="flex justify-between text-[10px] xl:text-xs">
            <li className="inline-flex gap-1">
              <CheckCircleIcon className="h-4 w-4 text-white" fill="#4CAF50" />
              Builder Ai
            </li>
            <li className="inline-flex gap-1">
              <CheckCircleIcon className="h-4 w-4 text-white" fill="#4CAF50" />{" "}
              Ai Suggestions
            </li>
            <li className="inline-flex gap-1">
              <CheckCircleIcon className="h-4 w-4 text-white" fill="#4CAF50" />{" "}
              Unlimited Slots
            </li>
          </ul>
          <div className="absolute left-1/2 top-full flex h-[99px] w-[270px] -translate-x-1/2 -translate-y-1/2 items-center rounded-[18px] bg-white px-5 font-montserrat text-black  shadow-md xl:w-[419px]">
            <div className="mr-3 text-[7px] font-medium xl:text-[9px]">
              Pay only
              <div className="relative -mt-1">
                <span className="absolute left-0 top-1/2 h-[1px] w-[90%] bg-black" />
                <p className="text-lg font-light xl:text-[20px]">49</p>
              </div>
            </div>
            <div className="text-2xl font-semibold text-[#94CF16] xl:text-4xl">
              &#8377; 29
            </div>
            <div className="ml-auto flex flex-col items-end gap-2">
              <span className="rounded-2xl bg-[#ECECEC] px-2 py-1 text-[6px] text-[#424141] xl:text-[8px]">
                For 14 Days
              </span>
              <button
                className="z-20 rounded-2xl bg-gradient-to-tr from-[#ECA1FF] to-[#923CFF] px-3 py-1 font-poppins text-[10px] font-medium text-white xl:text-xs"
                onClick={handlePayment}
              >
                Upgrade to pro
              </button>
            </div>
          </div>
        </div>
        {/* <p className="mt-14 w-full self-start pl-10 text-left font-montserrat font-semibold">
          No Auto Renewal
        </p> */}
      </div>
    </section>
  );
};

export default UpgradeToProCTAForm;
